export default __webpack_public_path__ + "static/media/mckensey.e813e6f5.png";